import { installmentBanks } from "../endpoints/installmentBanks.endpoints";
import $axios from "../http/accessor";

/** One instalment plan of a bank: pay over `months`, for `markup_percent` on top. */
export interface InstallmentTerm {
  id?: number;
  months: number;
  /** Added to the price over the whole term; 0 is an interest-free taksit. */
  markup_percent: number;
}

export interface InstallmentBank {
  id: number;
  name: string;
  image: string;
  background_color: string;
  accent_color: string;
  text_color: string;
  sort_order: number;
  is_active: boolean;
  terms: InstallmentTerm[];
}

const InstallmentBanksService = {
  getAllBanks: (page: number, count: number, search?: string) => {
    return $axios.get(installmentBanks.get_all, {
      params: { page, count, search },
    });
  },

  getSingleBank: (id: number) => {
    return $axios.get(installmentBanks.get_by_id(id));
  },

  createBank: (data: FormData) => {
    return $axios.post(installmentBanks.create, data);
  },

  updateBank: (id: number, data: FormData) => {
    return $axios.put(installmentBanks.edit(id), data);
  },

  deleteBank: (id: number) => {
    return $axios.delete(installmentBanks.delete(id));
  },
};

export default InstallmentBanksService;
